import type { IconSize } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import type { ReactElement } from "react";
import { InsightBanner, InsightBannerTooltip } from "@similarweb/ui-components";

type Props = {
    title: string;
    content: ReactElement | string;
    iconSize?: IconSize;
};

const SignalInsightTooltip = ({ title, content, iconSize = "xs" }: Props) => {
    return (
        <InsightBannerTooltip content={content}>
            <InsightBanner
                icon={
                    <SWReactIcons
                        size={iconSize}
                        iconName="light-bulb"
                    />
                }
                title={title}
            />
        </InsightBannerTooltip>
    );
};

export default SignalInsightTooltip;
